import React, {useEffect, useState, useRef} from 'react';
import mqtt from 'mqtt';
import { Switch, FormControlLabel, Box, Slider, Button } from '@mui/material';
import { ColorPicker, Hue, useColor } from 'react-color-palette';
import "react-color-palette/css";
import LightModeIcon from '@mui/icons-material/LightMode';
import { numberToIColor, numberToRGB, rgbToIColor, rgbToColorNumber, getGroupIDFromTopic } from '../validation/utils';
import ColorPickerPopup from '../components/ColorPickerPopup';
import { MQTT_BROKER_URL, MQTT_TOPIC_PREFIX } from '../constants';
import { initializeClientAndSubscribeToTopics, publishMessage, subscribeToTopic, cleanupClient, subscribeToTopics } from '../api/mqtt';
import { useDispatch } from 'react-redux';
import { disconnectMqtt} from '../redux/mqttSlice';
import { useSelector } from 'react-redux';
import { addGroup, updateGroupOnReduxAndServer } from '../redux/groupSlice';
import { addHeart } from '../redux/heartSlice';
import { updateGroup } from '../redux/groupSlice';
import { useNavigate } from 'react-router-dom';
import GroupContainer from '../components/GroupContainer';
import { Grid } from '@mui/material';
import { GroupSchema } from 'lumas-shared-schemas';


const GROUP_NAME = "KenzieLiamHeart";
const GROUP2_NAME = "Hermanos123";

const bgContainerStyles = {
  display: 'flex',
  backgroundColor: '#758aff',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
}

function DualColorPage() {
    const [switchState, setSwitchState] = useState(false);
    const [color, setColor] = useColor("rgb(255 0 0)");
    const [colorPickerPopupOpen, setColorPickerPopupOpen] = useState(false);
    const [tempColor, setTempColor] = useColor(color.hex);

    // react router
    const navigate = useNavigate();
    
    // Redux store state
    const dispatch = useDispatch();
    const groups = useSelector((state) => state.group.groups);
    const hearts = useSelector((state) => state.heart.hearts);

    useEffect(() => {
      if(groups.length === 0) {
        dispatch(addGroup({id: 'KenzieLiamHeart', name: 'KenzieLiam', color: 410, colorMode: 'solid', hearts: ['85:1F:64:27:34:9D'], members: [{email: 'Liam123@gmail.com', admin: true}]}));
        dispatch(addGroup({id: 'Hermanos123', name: 'Hermanos', color: 210, colorMode: 'solid', hearts: ['12:34:56:78:90:12', 'FF:FF:FF:FF:FF:FF'], members: [{email: "hugh@gmail.com", admin: true}] }));
        dispatch(addGroup({id: 'Hermanos1234', name: 'Hermanos', color: 210, colorMode: 'solid', hearts: ['12:34:56:78:90:12', 'FF:FF:FF:FF:FF:FF'], members: [{email: "hugh@gmail.com", admin: true}] }));
      }
    }, [dispatch, groups.length]);
      
    // useEffect(() => {
    //   // Must populate all groups and hearts in the store before subscribing to color topics (otherwise the colorListener won't find the group)
    //   if(hearts.length === 0) {
    //     dispatch(addGroup({id: 'KenzieLiamHeart', name: 'KenzieLiam', color: 410, colorMode: 'solid', hearts: ['85:1F:64:27:34:9D'], members: ['Liam123']}));
    //     dispatch(addHeart({id: '85:1F:64:27:34:9D', name: 'Heart 1', group: 'KenzieLiamHeart', owner: 'Liam123'}));
    //     dispatch(addGroup({id: 'Hermanos123', name: 'Hermanos', color: 210, colorMode: 'solid', hearts: ['12:34:56:78:90:12', 'FF:FF:FF:FF:FF:FF'], members: ['Liam123']}));
    //     dispatch(addHeart({id: '12:34:56:78:90:12', name: 'Bro Heart', group: 'Hermanos123', owner: 'Liam123'}));
    //     dispatch(addHeart({id: 'FF:FF:FF:FF:FF:FF', name: 'Bro Heart', group: 'Hermanos123', owner: 'Liam123'}));
    //     dispatch(addHeart({id: 'FF:FF:FF:FF:FF:FA', name: 'Bro Heart 2', owner: 'Liam123'}));
    //   }

    //   // Subscribe to color topics for all groups
    //   const topics = []
    //   groups.forEach((group) => topics.push(`${MQTT_TOPIC_PREFIX}${group.id}/color`));
    //   subscribeToTopics(topics, dispatch, colorListener);
    //   // initializeClientAndSubscribeToTopics(topics, dispatch, colorListener);

    //   // return () => {
    //   //   console.log("I am being cleaned up!");
    //   //   cleanupClient();
    //   // };
    // }, [dispatch, hearts.length]); // Empty dependency array ensures that the effect runs only once on component mount


    const colorListener = (topic, message) => {
      const group_id = getGroupIDFromTopic(topic);
      const group = groups.find((group) => group.id === group_id);
      if(group) {
        console.log("Group found: ", group.id, "updating color to: ", parseInt(message.toString()));
        const updatedGroup = GroupSchema.parse({
          ...group, 
          color: parseInt(message.toString())
        });
        dispatch(updateGroupOnReduxAndServer({id: group.id, updatedGroup: updatedGroup}));
      } else {
        console.log("No group found with ID: ", group_id);
      }
    };
  
    // onChange event handler for the switch
    const handleChange = (e) => {
      // Update the switch state
      let dualColorEnabled = e.target.checked;
      setSwitchState(dualColorEnabled);
  
      // update the colorMode on the MQTT topic
      if (dualColorEnabled) {
        publishMessage('KenzieLiamHeart/dualColor', 'true');
      } else {
        publishMessage('KenzieLiamHeart/dualColor', 'false');
      }
    };

    // handle color picker popup save
    const handleSave = () => {
        // set/update the color only if the save button is clicked
        setColor(tempColor);
        
        // update the color on the MQTT topic
        const colorNumber = rgbToColorNumber(tempColor.rgb.r, tempColor.rgb.g, tempColor.rgb.b);
        publishMessage('KenzieLiamHeart/LiamRcv', colorNumber.toString());
        publishMessage(MQTT_TOPIC_PREFIX + GROUP_NAME + '/color', colorNumber.toString());

        setColorPickerPopupOpen(false); // Close the popup when clicked outside or on a close button
    };

    const sampleGroups = [1,2,3,4,5]
  
    return (
      <Box sx={bgContainerStyles}>
        {colorPickerPopupOpen && <ColorPickerPopup title={"Pick a color:"} color={tempColor} setColor={setTempColor} handleSave={handleSave} handleCancel={() => setColorPickerPopupOpen(false)} />}
        <h2>KenzieLiamHeart settings</h2>
        <Button onClick={() => navigate('/page-2')}>Page 2</Button>
        <FormControlLabel control={<Switch onChange={handleChange} checked={switchState} />} label="Dual Color Mode"  />
        <Box sx={{width: '100%', marginTop: '30px'}}>
          
          {/* <Grid container spacing={2} style={{ width: '100%', padding: '20px', overflowX: 'auto', display: 'flex', flexDirection: 'row' }}> */}
          <Box sx={{overflowX: 'scroll', display: 'flex', flexDirection: 'row'}}>
            {groups.map((group, index) => (
              <Grid item key={index} style={{ flexShrink: 0, maxWidth: '70%', marginRight: '10px' }}>
                <GroupContainer 
                  groupName={group.name} 
                  numberMembers={group.members.length} 
                  numberHearts={group.hearts.length} 
                  colorMode={group.colorMode} 
                  onClick={() => {navigate(`/manage-group/${group.id}`)}} 
                />
              </Grid>
            ))}
            </Box>
          {/* </Grid> */}

          {/* <Grid container spacing={2} style={{width: '100%', padding: '20px', overflowX: 'auto', display: 'flex', flexDirection: 'row' }}> */}
          <Box sx={{overflowX: 'scroll', display: 'flex', flexDirection: 'row', backgroundColor: 'green'}}>

            {sampleGroups.map((sampleGroup, index) => (
              <Grid item key={index} style={{ flexShrink: 0, maxWidth: '50%',  marginLeft: '10px' }}>
                <Box sx={{width: '300px', height: '100px', backgroundColor: 'yellow'}}>
                </Box> 
              </Grid>
            ))}
          </Box>
          {/* </Grid> */}
          
        </Box>
      </Box>
    );
}
 
export default DualColorPage